import React from "react";
import { useNavigate } from "react-router-dom";
import CreateProject from "../../pages/common/CreateProject/CreateProject";

const RoleAwareCreateProject = ({ role }) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`/${role}/manage-projects`);
  };

  const handleCreateSuccess = () => {
    navigate(`/${role}/manage-projects`);
  };

  return (
    <CreateProject
      role={role}
      onCancel={handleCancel}
      onCreateSuccess={handleCreateSuccess}
    />
  );
};

export default RoleAwareCreateProject;
